/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import customStyles from "../../../../../assets/styles/customStyles";
import { Col, Row, Space } from "antd";
import { Button, Box, FormControlLabel, Switch } from "@mui/material";
import HomeImg from "../../../../../assets/images/icon_menus/HomeIcon.json";
import clsx from "clsx";
import MainHeader from "../../../../Shared/components/Header";
import { checkViewPermission } from '../../../../../helpers/utilities';
import { useSelector } from "react-redux";

const GlobalParameters = (props) => {

    const classes = customStyles();

    const [form, setForm] = useState({ send_email_notif: false });

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Global Parameters', history, 'Younote Admin')) {
            }
        }
    }, [roleManagement]);

    const handleSubmit = (e) => {
        e.preventDefault();
    }

    const changeHandler = (value) => {
        setForm({
            ...form,
            send_email_notif: !value,
        });
    }

    return (
        <React.Fragment>
            <MainHeader  {...props} title={'Admin'} img={HomeImg} links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Global Parameters', 'link': '' }]} />

            <div className={clsx(classes.margin40, classes.listTableMargin)} style={{ height: '100%' }}>
                <PrimaryCard
                    title={'Global Parameters'}
                    component={
                        <>

                            <Box
                                className={clsx(classes.teamForm, classes.removeUnderline)}
                                component="form"
                                autoComplete="off"
                                onSubmit={(e) => handleSubmit(e)}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                            >
                                <Row gutter={130}>
                                    <Col span={12}>
                                        <Typography variant={'h6'} style={{ color: '#14A4C2', fontSize: '14px' }}>General</Typography>
                                    </Col>
                                    <Col span={12} className={clsx(classes.textAlignRight)}>
                                        <Space direction="horizontal" align="center">
                                            <Button
                                                type='submit'
                                                color='primary'
                                                variant="contained"
                                                fullWidth
                                                className={clsx(classes.modalBtn, classes.bold, classes.disabled)}
                                            // onClick={() => handleSubmit()}
                                            >
                                                Update
                                            </Button>
                                        </Space>
                                    </Col>
                                    <Col span={24}>
                                        <FormControlLabel
                                            classes={{
                                                label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                            }}
                                            control={<Switch size='small' name="send_email_notif" className={clsx(classes.customSwitch)}
                                                onChange={(e) => changeHandler(form.send_email_notif)}
                                            />}
                                            label="Allow Notification"
                                            labelPlacement="top"
                                            checked={form.send_email_notif}
                                            className={clsx(classes.marginLeft0, classes.flexStart)}
                                        />
                                    </Col>
                                </Row>
                            </Box>

                        </>
                    }
                />
            </div>
        </React.Fragment>
    );
}
export default GlobalParameters